import { ReplaySubject } from 'rxjs';

export class MatSelectSearchUtil {
	/**
	 * Filters an array of objects based on search term and specified fields
	 * @param items - Array of items to filter
	 * @param searchTerm - The search term to filter by
	 * @param searchFields - Array of field names to search in
	 * @param filteredSubject - ReplaySubject to emit filtered results
	 */
	static filterItems<T>(
		items: T[],
		searchTerm: string | null | undefined,
		searchFields: (keyof T)[],
		filteredSubject: ReplaySubject<T[]>
	): void {
		if (!items) {
			return;
		}

		let search = searchTerm;
		if (!search) {
			filteredSubject.next(items.slice());
			return;
		} else {
			search = search.toLowerCase();
		}

		const filtered = items.filter((item) => {
			return searchFields.some((field) => {
				const fieldValue = item[field];
				if (fieldValue == null) return false;

				return String(fieldValue).toLowerCase().indexOf(search!) > -1;
			});
		});

		filteredSubject.next(filtered);
	}

	/**
	 * Alternative: Search all string fields in the object
	 * @param items - Array of items to filter
	 * @param searchTerm - The search term to filter by
	 * @param filteredSubject - ReplaySubject to emit filtered results
	 */
	static filterAllStringFields<T>(
		items: T[],
		searchTerm: string | null | undefined,
		filteredSubject: ReplaySubject<T[]>
	): void {
		if (!items) {
			return;
		}

		let search = searchTerm;
		if (!search) {
			filteredSubject.next(items.slice());
			return;
		} else {
			search = search.toLowerCase();
		}

		const filtered = items.filter((item) => {
			return Object.values(item as any).some((value) => {
				if (typeof value === 'string') {
					return value.toLowerCase().indexOf(search) > -1;
				}
				return false;
			});
		});

		filteredSubject.next(filtered);
	}
}
